import {Injectable} from '@angular/core';
import {ErrorModel} from '../../../app.model';
import {ACTION_TYPES} from '../../../app.types';
import {AppStore} from '../../../store/store';
import {SegmentValidationModel} from './validation.model';

export interface SegmentValidationsAction {
  type: string;
  segmentValidations?: SegmentValidationModel[];
  segmentValidation?: SegmentValidationModel;
  error?: ErrorModel;
  validationId?: number;
}

@Injectable()
export class SegmentValidationActions {

  static dispatchValidationListForSegment(segmentValidations: SegmentValidationModel[], appStore: AppStore) {
    appStore.dispatch({type: ACTION_TYPES.SEGMENT_VALIDATION_LIST_GET, segmentValidations});
  }

  static dispatchCreatedValidation(segmentValidationModel: SegmentValidationModel, appStore: AppStore) {
    appStore.dispatch({type: ACTION_TYPES.SEGMENT_VALIDATION_SET, segmentValidation: segmentValidationModel});
  }

  static dispatchDeleteError(appStore: AppStore, error: ErrorModel) {
    appStore.dispatch({type: ACTION_TYPES.SEGMENT_VALIDATION_ERROR, error});
  }

  static dispatchSuccessDelete(appStore: AppStore, id: number) {
    appStore.dispatch({type: ACTION_TYPES.SEGMENT_VALIDATION_DELETE, validationId: id});
  }

  static dispatchInitDialog(appStore: AppStore) {
    appStore.dispatch({type: ACTION_TYPES.SEGMENT_VALIDATION_INIT_DIALOG});
  }

  static dispatchUpdateSuccess(validation: SegmentValidationModel, appStore: AppStore) {
    appStore.dispatch({type: ACTION_TYPES.SEGMENT_VALIDATION_UPDATE, segmentValidation: validation});
  }

  static dispatchUpdateError(appStore: AppStore, error: ErrorModel) {
    appStore.dispatch({type: ACTION_TYPES.SEGMENT_VALIDATION_ERROR, error});
  }

  static dispatchValidationError(appStore: AppStore, error: ErrorModel) {
    appStore.dispatch({type: ACTION_TYPES.SEGMENT_VALIDATION_ERROR, error});
  }

}
